import { render } from "./MultiDropdown.vue?vue&type=template&id=24b126cc"
import script from "./MultiDropdown.vue?vue&type=script&lang=js"
export * from "./MultiDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__